/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-rename */
import {
  Typography,
  Button,
  Box,
  Grid,
  useTheme,
  TextField,
  Autocomplete,
  Input,
  FormControlLabel,
  Checkbox,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useState, useEffect, useRef, useCallback } from "react";
import AboutUs from "../../components/about-us";
import { useNavigate } from "react-router-dom";
import { pages } from "../../assets/data/all-data";
import TopTabBar from "../../components/app-bar";
import UpcomingEventsCard from "../../components/card/upcoming-events-card";
import BottomTab from "../../components/bottom-tab";
import Color from "../../theme/color";
import { usePersistentState } from "../../contexts/global-context";
import { GET } from "../../config/https";
import APIS from "../../config/api";
import { filter } from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetLocalStorage } from "../../utils/local-storage";
import axios from "axios";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { isEmpty } from "../../utils/validator";
import SeparateDateTime from "../../utils/sparate-time-date";
import HostBenefit from "../../components/host-benefits";

interface Country {
  country: string;
}
interface Region {
  region: string;
}

const HomeScreen = () => {
  const theme = useTheme();
  const [state, dispatch]: any = usePersistentState();
  const [loginInfo, setLoginInfo] = useState(false);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [eventList, setEventList] = useState<any>([]);
  const [checked, setChecked] = useState(false);
  const [allOrganizer, setAllOrganizer] = useState<any>([]);
  const [allCategories, setAllCategories] = useState<any>([]);
  const [allState, setAllState] = useState<any>([]);
  const [filterName, setFilterName] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [toData, setToData] = useState<string>("");
  const [fromData, setFromData] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const loader = useRef<HTMLDivElement | null>(null);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [searchOrganizerData, setSearchOrganizerData] = useState({
    value: "",
    label: "",
  });
  const [searchCategoryData, setSearchCategoryData] = useState({
    value: "",
    label: "",
  });
  const [searchCityData, setSearchCityData] = useState({
    value: "",
    label: "",
  });
  const [searchCurrentCityData, setSearchCurrentCityData] = useState({
    value: "",
    label: "",
  });

  const [searchCurrentCountryData, setSearchCurrentCountryData] = useState({
    value: "",
    label: "",
  });

  const allCategoryData = allCategories?.map((x: any) => ({
    value: x.id,
    label: x.displayName,
  }));
  const allOrganizerData = allOrganizer
    ?.filter((x: any) => x?.companyName)
    .map((x: any) => ({
      value: x.id,
      label: x.companyName,
    }));
  const allCityData = allState?.map((x: any) => ({
    label: x.name,
    value: x.id,
  }));

  useEffect(() => {
    dispatch({ EventVenue: {} });
    dispatch({ EventFaq: {} });
    dispatch({ EventSchedule: {} });
    dispatch({ EventTicketConfig: {} });
    dispatch({
      Event: {},
    });
  }, []);

  useEffect(() => {
    if (hasMore) {
      fetchData();
    }
  }, [
    page,
    hasMore,
    searchCategoryData,
    searchOrganizerData,
    searchCityData,
    searchCurrentCountryData,
    fromData,
    toData,
    checked,
  ]);

  const imageList = [
    "https://images.pexels.com/photos/625644/pexels-photo-625644.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg?auto=compress&cs=tinysrgb&w=1600",
    "https://images.pexels.com/photos/167491/pexels-photo-167491.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    "https://images.pexels.com/photos/154147/pexels-photo-154147.jpeg",
    "https://images.pexels.com/photos/2263410/pexels-photo-2263410.jpeg",
    "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    "https://images.pexels.com/photos/625644/pexels-photo-625644.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageList.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [imageList.length]);

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  useEffect(() => {
    getAllUsers();
    getAllEventCategories();
    getAllState();
  }, []);

  useEffect(() => {
    if (searchCityData.value) {
      fetchData();
    }
    fetchCityData();
  }, [
    searchOrganizerData,
    searchCategoryData,
    searchCityData,
    toData,
    fromData,
    filterName,
  ]);

  useEffect(() => {
    if (searchCurrentCityData.label) {
      fetchData();
    }
  }, [checked, searchCurrentCityData]);

  const fetchCityData = async () => {
    try {
      setLoading(true);
      const cityResponse = await GET(APIS.GET_CITY_BY_IP + APIS.IP_INFO_TOKEN);
      const country: string | undefined = (cityResponse as Country)?.country;
      const region: string | undefined = (cityResponse as Region)?.region;

      if (country) {
        setSearchCurrentCountryData({ value: country, label: country });
      }
      if (region) {
        setSearchCurrentCityData({ value: region, label: region });
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getSate = () => {
    if (checked && isEmpty(searchCityData.label)) {
      return searchCurrentCityData.label;
    }
    if (!checked && !isEmpty(searchCityData.label)) {
      return searchCityData.label;
    }
    if (!checked && isEmpty(searchCityData.label)) {
      return "";
    }
  };


  const fetchData = useCallback(async () => {

    setLoading(true);
    try {
      await GET(
        APIS.GET_EVENT_DETAIL +
        `?CategoryId=${searchCategoryData.value}` +
        `&OrganizerId=${searchOrganizerData.value}` +
        `&IsPublish=true&isAll=${searchOrganizerData.value ? false : true
        }&PageSize=100&State=${getSate()}` +
        `&Country=${!checked && isEmpty(searchCityData.label)
          ? searchCurrentCountryData.label
          : ""
        }` +
        `&StartDate=${fromData}` +
        `&EndDate=${toData}` +
        `&SortProperty=startDateUtc&IsDescending=false&PageNumber=${page}&EventName=${filterName ? filterName : ""
        }`
      )
        .then((res: any) => {
          if (res?.isSuccess) {
            // setEventList(res.result);
            if (res?.result?.length === 0) {
              setHasMore(false);
            } else {
              let newData = res.result;
              setEventList((prevData: any) => {
                // Remove duplicate items
                const newItems = res.result.filter(
                  (newItem: any) =>
                    !prevData.some((item: any) => item.id === newItem.id)
                );
                return [...prevData, ...newItems];
              });
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
          setHasMore(false);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasMore(false);
      setLoading(false);
    }
  }, [
    page,
    searchCategoryData,
    searchOrganizerData,
    searchCityData,
    searchCurrentCountryData,
    fromData,
    toData,
    checked,
    filterName,
  ]);


  useEffect(() => {
    setEventList([]); // Clear previous items
    setPage(0); // Reset page number to 1
    setHasMore(true); // Reset hasMore to true
  }, [
    searchCategoryData,
    searchOrganizerData,
    searchCityData,
    searchCurrentCountryData,
    fromData,
    toData,
    checked,
  ]);
  const debounce = (func: Function, delay: number) => {
    let debounceTimer: NodeJS.Timeout;
    return (...args: any) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func(...args), delay);
    };
  };

  useEffect(() => {
    if (loading || !hasMore) return;

    const handleObserver: IntersectionObserverCallback = (entries) => {
      const target = entries[0];
      if (target.isIntersecting) {
        setPage((prevPage) => prevPage + 1);
      }
    };

    const observer = new IntersectionObserver(handleObserver, { threshold: 1 });

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) {
        observer.unobserve(loader.current);
      }
    };
  }, [loading, hasMore]);
  const handleCheckBoxChange = (event: any) => {
    setChecked(event.target.checked);
    if (!isEmpty(searchCityData.label)) {
      setSearchCityData({
        value: "",
        label: "",
      });
    }
  };

  const getAllUsers = async () => {
    await GET(APIS.GET_ALL_USER + `?PageSize=10000`)
      .then((res: any) => {
        if (res?.isSuccess) {
          setAllOrganizer(res?.result);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };

  const getAllEventCategories = async () => {
    let param: any = {
      PageSize: 100,
      IsDescending: false,
      SortProperty: "displayName",
    };
    await GET(APIS.GET_ALL_EVENT_CATEGORIES, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setAllCategories(res?.result);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };

  const getAllState = async () => {
    await GET(APIS.GET_ALL_STATE)
      .then((res: any) => {
        if (res?.isSuccess) {
          setAllState(res?.result);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };

  const applySortFilter = (data?: any, query?: any) => {
    const stabilizedThis = data?.map((el: any) => el);

    if (query) {
      return filter(
        data,
        (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    }
    return stabilizedThis.map((el: any) => el);
  };

  const handleFilterByName = (event: any) => {
    setFilterName(event.target.value);
  };

  // const eventCard = applySortFilter(eventList, filterName);
  const eventCard = eventList;
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
  const isNotFound = !eventCard.length && !!filterName;
  const count = eventCard.length;
  const onChangeToData = async (e: any) => {
    let date = null;
    var temp = await SeparateDateTime(e?.$d);
    date = temp?.date;
    setToData(date);
  };

  const onChangeFormData = async (e: any) => {
    let date = null;
    var temp = await SeparateDateTime(e?.$d);
    date = temp?.date;
    setFromData(date);
  };

  return (
    <>
      <section id="home">
        <div
          style={{
            backgroundImage: `url(${imageList[currentImageIndex]})`,
            backgroundSize: isSmallScreen ? "cover" : "cover",
            height: isSmallScreen ? "70vh" : "80vh",
            width: "100%",
            backgroundPosition: "center bottom",
            position: "relative",
            backgroundAttachment: "fixed",
            transition: "background-image 0.5s ease-in-out",
          }}
        >
          <div style={{ backgroundColor: "#000", opacity: 0.6, transition: "background 0.3s, border-radius 0.3s, opacity 0.3s", position: "relative", height: isSmallScreen ? "70vh" : "80vh" }} />
        </div>
      </section>
      <Grid container spacing={0} alignItems="center" justifyContent="center" position={"absolute"} top={0} sx={{ display: "flex", flexDirection: "column" }}>
        <Grid item xs={12}>
          <TopTabBar backgroundColors={"transparent"} textColor={"#fff"} boxShadow={"none"} iconColor={"#fff"} pages={pages} event={"events"} />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height={isSmallScreen ? "40vh" : "calc(83vh - 44px)"} color="white" marginTop={isSmallScreen ? "130px" : "0"}>
              <Typography style={{ color: "#fff", fontFamily: "Poppins", fontWeight: 600, fontSize: isSmallScreen ? "30px" : "80px" }} align="center" variant="h1">
                FIND EVENTS NEAR YOU
              </Typography>
              {loginInfo === null ? (
                <Button onClick={() => { navigate("/login"); }}
                  style={{ backgroundColor: Color.primary, borderRadius: 30, marginTop: 20, color: "white", width: 150, height: 50, fontWeight: 600, fontSize: "17px", }}>
                  Create Event
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    navigate("/dashboard/event/add");
                  }}
                  style={{
                    backgroundColor: Color.primary,
                    borderRadius: 30,
                    marginTop: 20,
                    color: "white",
                    width: 150,
                    height: 50,
                    fontWeight: 600,
                    fontSize: "17px",
                  }}
                >
                  Create Event
                </Button>
              )}
            </Box>
          </div>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{
            padding: "0 20px 0 20px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid
            container
            spacing={isMobile ? 2 : 0}
            alignItems="center"
            border="1px solid  #d9d9d9	"
            justifyContent="center"
            style={{
              padding: "20px 20px",
              marginTop: isMobile ? "20px" : "-42px",
              backgroundColor: "white",
              borderRadius: isMobile ? "30px" : "20px",
              maxWidth: isMobile ? "1100px" : "1150px",
              marginLeft: 0,
              width: "100%",
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{
                paddingLeft: "5px",
                paddingRight: "5px",
                marginBottom: isMobile ? 0 : 10,
              }}
            >
              <Input
                value={filterName || ""}
                onChange={handleFilterByName}
                id="outlined-adornment-weight"
                placeholder="Search By Event Name"
                aria-describedby="outlined-weight-helper-text"
                fullWidth
                style={{ border: "none", paddingLeft: 10 }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={2.4}
              style={{ paddingRight: "5px", paddingLeft: "5px" }}
            >
              <Autocomplete
                size="small"
                disablePortal
                id="combo-box-demo"
                style={{
                  backgroundColor: "#fff",
                  width: "100%",
                }}
                options={allCategoryData}
                value={searchCategoryData}
                onChange={(event, newValue: any) => {
                  if (newValue === null) {
                    setSearchCategoryData({ value: "", label: "" });
                  } else {
                    setSearchCategoryData(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: "100%" }}
                    placeholder="Category"
                  />
                )}
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    style={{
                      ...props.style,
                      border: " 1px solid #acacac",
                    }}
                  />
                )}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={2.4}
              style={{ paddingRight: "5px", paddingLeft: "5px" }}
            >
              <Autocomplete
                size="small"
                disablePortal
                style={{ backgroundColor: "#fff", width: "100%" }}
                id="combo-box-demo"
                options={allOrganizerData}
                value={searchOrganizerData}
                onChange={(event, newValue: any) => {
                  if (newValue === null) {
                    setSearchOrganizerData({ value: "", label: "" });
                  } else {
                    setSearchOrganizerData(newValue);
                  }
                }}
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    style={{
                      ...props.style,
                      border: " 1px solid #acacac",
                    }}
                  />
                )}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Organizer" />
                )}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={2.4}
              style={{
                paddingRight: "5px",
                paddingLeft: "5px",
              }}
            >
              <Autocomplete
                size="small"
                style={{ backgroundColor: "#fff", width: "100%" }}
                disablePortal
                id="combo-box-demo"
                options={allCityData}
                value={searchCityData}
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    style={{
                      ...props.style,
                      border: " 1px solid #acacac",
                    }}
                  />
                )}
                onChange={(event, newValue: any) => {
                  if (newValue === null) {
                    setSearchCityData({ value: "", label: "" });
                  } else {
                    setChecked(false);
                    setSearchCityData(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Where" />
                )}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={2.4}
              style={{ paddingRight: "5px", paddingLeft: "5px" }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{ width: "100%" }}
                  slotProps={{
                    textField: {
                      size: "small",
                      name: "From Date",
                      error: false,
                      placeholder: "From Date",
                    },
                  }}
                  disablePast
                  format="ll"
                  onChange={(event) => onChangeFormData(event)}
                />
              </LocalizationProvider>
            </Grid>
            <Grid
              item
              xs={12}
              md={2.4}
              style={{ paddingRight: "5px", paddingLeft: "5px" }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{ width: "100%" }}
                  slotProps={{
                    textField: {
                      size: "small",
                      name: "To Date",
                      error: false,
                      placeholder: "To Date",
                    },
                  }}
                  disablePast
                  format="ll"
                  onChange={(event) => onChangeToData(event)}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Grid>
        <div
          id="events"
          style={{
            flexDirection: "column",
            display: "flex",
            justifyContent: "center",
            position: "relative",
            top: isMobile ? "15px" : "30px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {checked ? (
              <>
                <div style={{ display: "flex" }}>
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 700,
                      color: "#333333",
                      fontSize: isMobile ? "24px" : "38px",
                      display: "flex",
                      justifyContent: "center",
                      marginRight: "5px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    Events in
                  </Typography>
                  <Typography variant="h3" style={{ fontSize: isMobile ? "24px" : "38px", display: "flex", fontWeight: 700, justifyContent: "center", color: Color.primary }}>
                    {searchCurrentCityData.label}.
                  </Typography>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <FormControlLabel control={<Checkbox checked={checked} onChange={handleCheckBoxChange} style={{ marginLeft: "5px", color: "gray" }} />}
                    label="Current State" style={{ color: "gray", fontSize: "20px", width: "fit-content" }} />
                </div>
              </>
            ) : (
              <>
                <div id="eventin" style={{ display: "flex" }}>
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 700,
                      color: "#333333",
                      fontSize: isMobile ? "24px" : "38px",
                      display: "flex",
                      justifyContent: "center",
                      marginRight: "5px",
                    }}
                  >
                    Events in{" "}
                  </Typography>
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 700,
                      color: Color.primary,
                      fontSize: isMobile ? "24px" : "38px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {searchCityData.label === ""
                      ? searchCurrentCountryData.label
                      : searchCityData.label}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleCheckBoxChange}
                        style={{
                          marginLeft: "5px",
                          color: "gray",
                        }}
                      />
                    }
                    label="Current State"
                    style={{
                      color: "gray",
                      fontSize: "20px",
                      width: "fit-content",
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <Grid
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "center",
              margin: isMobile ? "30px 0px 20px 0px" : "25px 0px 15px 0px",
            }}
            item
            xs={12}
          >
            <Typography
              style={{
                color: "#999797",
                textAlign: "center",
                fontSize: 24,
              }}
            >
              Showing {count} of {count}
            </Typography>
          </Grid>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justifyContent="center"
            marginBottom={10}
          >
            <Grid item xs={12} sm={12}>
              <UpcomingEventsCard cartData={eventCard} loading={page === 0 && loading ? true : false} />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  ref={loader}
                  style={{
                    // height: "100px",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "auto",
                  }}
                >
                  {loading && page != 0 ? <CircularProgress /> : null}
                </div>
              </div>
              {isNotFound && !loading && (
                <>
                  <Typography
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      marginBottom: 30,
                      color: "#555",
                      fontSize: 30,
                    }}
                    paragraph
                  >
                    No Match Result Found!
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </div>
        <AboutUs />
        <HostBenefit />
        <BottomTab />
      </Grid>
      <Grid item xs={12} sm={3} md={1}></Grid>
    </>
  );
};

export default HomeScreen;
